import { Stock } from "Context/context";
import { useContext } from "react";

export function useStock() {
  return useContext(Stock);
}
